(($) => {
  function init() {
    setViewport();
    $(window).on("resize orientationchange", setViewport);
    gsap.registerPlugin(ScrollTrigger);
    initHeader();
  }

  function setViewport() {
    const viewport = document.querySelector("meta[name=viewport]");
    if (!viewport) return;
    if (screen.width >= 768) {
      viewport.setAttribute("content", "width=1260");
    } else {
      viewport.setAttribute("content", "width=390");
    }
  }

  function initHeader() {
    // dvhの代わりに--vh_pxを使用
    function setVh() {
      document.documentElement.style.setProperty('--vh_px', window.innerHeight + 'px');
    }
    window.addEventListener('load', setVh);
    window.addEventListener('resize', setVh);

    const $header = $('.ap-header');
    if ($header.length) {
      ScrollTrigger.create({
        trigger: "body",
        start: "top+=100 top",
        onEnter: () => {
          $header.addClass("-fixed");

        },
        onLeaveBack: () => {
          $header.removeClass("-fixed");
        },
      });

      const $menu_button = $header.find(".menu_button");
      const $header_bg = $(".ap-header_bg");
      const $menu = $header.find(".menu");

      $menu_button.on("click", (event) => {
        $menu_button.toggleClass("-open");
        $menu.toggleClass('-open').stop().slideToggle(200);
        $header_bg.stop().fadeToggle(200);
      });

      $('.ap-header .menu a, .ap-header_bg').on("click", (event) => {
        $menu_button.removeClass("-open");
        $menu.removeClass('-open').stop().slideUp(200);
        $header_bg.stop().fadeOut(200);
      });

      $menu.find(".lv1_title").on("click", (event) => {
        $(event.currentTarget).toggleClass("-open").next(".lv2").stop().slideToggle(200);
      });
    }
  }

  function start() {
    // 画像やリソースの読み込み完了後に実行したい処理
    // 例: ローディングアニメーションの非表示など
  }

  // DOMContentLoadedで初期化
  document.addEventListener("DOMContentLoaded", init, { once: true });
  // windowのloadイベントでstartを実行
  window.addEventListener("load", start, { once: true });
})(jQuery3);
